"use strict";

module.exports = {
  0: 'Member',
  1: 'Administrator',
  2: 'Super Administrator'
};